import { render, staticRenderFns } from "./AdsFlatRentBuy.vue?vue&type=template&id=43bcb65f"
import script from "./AdsFlatRentBuy.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdsFlatRentBuy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports